// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__25dwT","footer":"ModalError_footer__24FJ2"};